/**
 * useBodyScrollLock — ref-counted body scroll lock for nested modals.
 *
 * The naive `prev = document.body.style.overflow; set 'hidden'; restore prev`
 * pattern races when modals nest: B captures A's 'hidden' as its prev and
 * never restores to ''. This counter-based hook locks while any consumer is
 * active and only restores the original value when the last consumer unmounts.
 *
 * Usage:  useBodyScrollLock(isOpen);
 */
import { useEffect } from "react";

let lockCount = 0;
let originalOverflow = null;

export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active || typeof document === "undefined") return undefined;
    if (lockCount === 0) {
      originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    lockCount += 1;
    return () => {
      lockCount -= 1;
      if (lockCount <= 0) {
        lockCount = 0;
        document.body.style.overflow = originalOverflow || "";
        originalOverflow = null;
      }
    };
  }, [active]);
}
